import styled from '@mui/material/styles/styled'

//#region ========== STYLED COMPONENTS ==========

export const Actions = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  height: '36px',
  flexBasis: '3',
  fontSize: '14px',
  lineHeight: '36px',
  minWidth: '410px',
  textAlign: 'right',
})

export const Container = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2),
  position: 'relative',
  minWidth: '700px',
  width: '100%',

  ' a': {
    color: '#005aa3',
    fontSize: '14px',
    textDecoration: 'none',
  },
}))

export const FooterLink = styled('a')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexFlow: 'row no-wrap',
  fontSize: '14px',
  color: theme.palette.text.primary,
  lineHeight: '40px',
  margin: '0 -20px',
  padding: '0 20px',
  cursor: 'pointer',
  transition: 'all 0.25s',

  '::hover': {
    backgroundColor: '#f7f7f7',
  },
}))

export const ManageLeadToConvert = styled('div')({
  transition: 'all 0.25s ease-in-out',
})

export const NextAction = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flexBasis: '1',
  minWidth: '80px',
})

export const NextActionDate = styled('div')({
  fontSize: '12px',
  color: '#19305a',
})

export const ParentHeader = styled('div', {
  name: 'ParentHeader',
  shouldForwardProp: (prop) => prop !== 'detailPage',
})<{
  detailPage?: boolean
}>(({ theme, detailPage }) => ({
  minHeight: '36px',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: detailPage ? 0 : theme.spacing(0.4),
  [theme.breakpoints.down('lg')]: {
    justifyContent: detailPage ? 'end' : 'space-between',
  },
}))
//#endregion
